import React from 'react';
import { EventMapScopedProps } from '../../types';

export type EventMapLayoutProps = Pick<EventMapScopedProps, 'shouldDisplayMap'>;

export const EventMapLayout = ({ shouldDisplayMap }: EventMapLayoutProps) => {
    if (!shouldDisplayMap) {
        return null;
    }

    return (
        <div className="event-listing-footer eds-l-pad-bot-5">
            <div id="listings-root__event-location-map" tabIndex={-1}></div>
        </div>
    );
};
